<div class="modal-header border-0 d-flex justify-content-between align-items-start gap-3">

    <div class="flex-grow-1">

        <span class="badge bg-success mb-2 px-3 py-2 rounded-pill">
            {{ 'ClockFlex' | translate }}
        </span>

        <h4 class="h3 fw-bold mb-1" id="modal-basic-title" style="font-size: 1.7rem;">
            {{ 'Strugling_With_Scheduling' | translate }}
        </h4>

        <p class="text-muted mb-0 small text-break">
            {{ 'We_help_businesses_manage_bookings_clients_and_time_smoothly' | translate }}
        </p>

    </div>

    <button type="button" class="btn-close shadow-none flex-shrink-0" aria-label="Close"
        (click)="closeModal.emit('close')">
    </button>

</div>

<div class="modal-body pt-3">

    @if (isSubmitted) {

    <!-- Success UI -->

    <div class="success-container text-center py-5">

        <div class="success-icon mx-auto mb-4">
            <i class="fa-solid fa-check"></i>
        </div>

        <h3 class="fw-bold mb-3">
            {{ 'Thank_You' | translate }}
        </h3>

        <p class="text-muted fs-5 mb-4">
            {{ 'We_will_get_in_touch_with_you_soon' | translate }}
        </p>

        <div class="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill bg-light border">

            <span class="spinner-grow spinner-grow-sm text-success"></span>

            <span class="small fw-semibold">
                {{ 'Our_team_will_contact_you_shortly' | translate }}
            </span>

        </div>

    </div>

    } @else {

    <!-- Form -->

    <form autocomplete="off" [formGroup]="contactForm" (ngSubmit)="onSubmit()">

        <!-- Name -->

        <div class="mb-3">

            <label for="name" class="form-label fw-semibold">
                {{ 'Full_Name' | translate }}
            </label>

            <div class="input-group custom-input">

                <span class="input-group-text">
                    <i class="fa-solid fa-user"></i>
                </span>

                <input type="text" id="name" class="form-control" formControlName="name" placeholder="John Doe">

            </div>

            @if (contactForm.get('name')?.invalid &&
            contactForm.get('name')?.touched) {

            <div class="text-danger small mt-1">
                {{ 'Name_is_required' | translate }}
            </div>

            }

        </div>

        <!-- Email -->

        <div class="mb-3">

            <label for="email" class="form-label fw-semibold">
                {{ 'Email' | translate }}
            </label>

            <div class="input-group custom-input">

                <span class="input-group-text">
                    <i class="fa-solid fa-envelope"></i>
                </span>

                <input type="email" id="email" class="form-control" formControlName="email"
                    placeholder="john@example.com">

            </div>

            @if (contactForm.get('email')?.invalid &&
            contactForm.get('email')?.touched) {

            <div class="text-danger small mt-1">
                {{ 'Valid_email_is_required' | translate }}
            </div>

            }

        </div>

        <!-- Phone -->

        <div class="mb-3">

            <label for="phone" class="form-label fw-semibold">
                {{ 'Phone' | translate }}
            </label>

            <div class="input-group custom-input">

                <span class="input-group-text">
                    <i class="fa-solid fa-phone"></i>
                </span>

                <input type="tel" id="phone" class="form-control" formControlName="phone" pattern="[0-9]{10}"
                    placeholder="9876543210">

            </div>

            <small class="text-muted">
                {{ '10_digit_number' | translate }}
            </small>

            @if (contactForm.get('phone')?.invalid &&
            contactForm.get('phone')?.touched) {

            <div class="text-danger small mt-1">
                {{ 'Valid_phone_is_required' | translate }}
            </div>

            }

        </div>

        <!-- Subject -->

        <div class="mb-3">

            <label for="subject" class="form-label fw-semibold">
                {{ 'Subject' | translate }}
            </label>

            <div class="input-group custom-input">

                <span class="input-group-text">
                    <i class="fa-solid fa-tag"></i>
                </span>

                <input type="text" id="subject" class="form-control" formControlName="subject"
                    placeholder="Need scheduling help">

            </div>

            @if (contactForm.get('subject')?.invalid &&
            contactForm.get('subject')?.touched) {

            <div class="text-danger small mt-1">
                {{ 'subject_is_required' | translate }}
            </div>

            }

        </div>

        <!-- Message -->

        <div class="mb-2">

            <label for="message" class="form-label fw-semibold">
                {{ 'Message' | translate }}
            </label>

            <textarea id="message" class="form-control custom-textarea" formControlName="message" rows="4"
                placeholder="Describe your scheduling problem...">
            </textarea>

            @if (contactForm.get('message')?.invalid &&
            contactForm.get('message')?.touched) {

            <div class="text-danger small mt-1">
                {{ 'Message_is_required' | translate }}
            </div>

            }

        </div>

    </form>

    }

</div>

@if (!isSubmitted) {

<div class="modal-footer border-0 pt-0">

    <button type="button" class="btn btn-light px-4 py-2 rounded-3" (click)="closeModal.emit('close')">

        {{ 'Close' | translate }}

    </button>

    <button type="submit" class="btn btn-dark px-4 py-2 rounded-3 shadow-sm" [disabled]="contactForm.invalid"
        (click)="onSubmit()">

        <i class="fa-solid fa-paper-plane me-2"></i>

        {{ 'Send_Message' | translate }}

    </button>

</div>

}